import { isEmpty, find, get, map, compose } from 'lodash/fp';
import { createAsyncActionTypes } from '@mews/framework';
import { createFetchAction, getOrEmptyString } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { setEnterpriseIntegrations } from '@mews-commander/legacy-entities/src/ducks/enterpriseIntegrations';
import { setMessages } from '@mews-commander/legacy-entities/src/ducks/messages';
import { setSimpleUsers } from '@mews-commander/legacy-entities/src/ducks/simpleUsers';
import { setThreads, updateThread } from '@mews-commander/legacy-entities/src/ducks/threads';
import { setProfiles } from '@mews-commander/legacy-entities/src/ducks/profiles';
import { setThreadsMembership } from '@mews-commander/legacy-entities/src/ducks/threadsMembership';
import { prefix } from '../module';

const THREADS_COUNT_TO_FETCH = 20;

const THREAD_DATA_FETCH = prefix('THREAD_DATA_FETCH');
export const [THREAD_DATA_FETCH_STARTED, THREAD_DATA_FETCH_SUCCEEDED, THREAD_DATA_FETCH_FAILED] =
    createAsyncActionTypes(THREAD_DATA_FETCH);

const THREAD_EXTENT = {
    integrations: true,
    profiles: true,
    users: true,
};

const fetch =
    (params: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { messageThreadComponent } = container();
        const enterpriseId = getCurrentEnterpriseId();

        const promise = messageThreadComponent.getAll({ ...params, enterpriseId }).then((data: $TSFixMe) => {
            const { integrations, messages, users, profiles, messageThreads, threadProfileMemberships } = data;
            if (!isEmpty(messages)) {
                dispatch(setMessages(messages));
            }
            if (!isEmpty(users)) {
                // TODO remove when https://mews.myjetbrains.com/youtrack/issue/RND-30605 is fixed
                const enhancedUsers = map(({ id, ...other }) => {
                    const profileId = compose(
                        get('id'),
                        // @ts-expect-error $TSFixMeError: Argument of type 'unknown' is not assignable to parameter of type 'null | undefined'.
                        find((profile) => getOrEmptyString(['data', 'value', 'userId'])(profile) === id)
                    )(profiles);

                    return {
                        ...other,
                        id,
                        profileId,
                    };
                })(users);

                // @ts-expect-error $TSFixMeError: Argument of type '{ id: any; profileId: any; }[]' is not assignable to parameter of type 'SimpleUser[]'.
                dispatch(setSimpleUsers(enhancedUsers));
            }
            if (!isEmpty(profiles)) {
                dispatch(setProfiles(profiles));
            }
            if (!isEmpty(messageThreads)) {
                dispatch(setThreads(messageThreads));
            }
            if (!isEmpty(threadProfileMemberships)) {
                dispatch(setThreadsMembership(threadProfileMemberships));
            }
            if (!isEmpty(integrations)) {
                dispatch(setEnterpriseIntegrations({ integrations, enterpriseId }));
            }

            return data;
        });

        return dispatch(createFetchAction(THREAD_DATA_FETCH, promise));
    };

export const fetchThreadsList = ({ threadType, startIndex = 0, count = THREADS_COUNT_TO_FETCH }: $TSFixMe) =>
    fetch({ startIndex, count, threadType, extent: THREAD_EXTENT });

export const fetchSingleThread = (threadId: $TSFixMe) => {
    const params = {
        messageThreadIds: [threadId],
        extent: {
            ...THREAD_EXTENT,
            threadProfileMemberships: true,
            messages: true,
        },
    };
    return fetch(params);
};

export const fetchThreadsMembers = (threadIds: $TSFixMe) => {
    const params = {
        messageThreadIds: threadIds,
        extent: {
            threadProfileMemberships: true,
            users: true,
            profiles: true,
        },
    };

    return fetch(params);
};

export const fetchThreadsMessages = (threadIds: $TSFixMe) => {
    const params = {
        messageThreadIds: threadIds,
        extent: {
            ...THREAD_EXTENT,
            messages: true,
        },
    };

    return fetch(params);
};

export const markThreadRead =
    (threadId: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { messageThreadComponent } = container();
        return messageThreadComponent.markRead(threadId).then(() => dispatch(updateThread(threadId, { isRead: true })));
    };

export const updateThreadSubject =
    ({ subjectDraft, threadId }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { messageThreadComponent } = container();
        return messageThreadComponent
            .updateSubject(threadId, subjectDraft)
            .then(() => dispatch(updateThread(threadId, { subject: subjectDraft })));
    };
